"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _theme = require("../../theme");

var _default = {
  MuiButton: {
    contained: {
      "&.Mui-disabled": {
        // When button isBusy or isDone, the button is
        // disabled but does not have disabled colour
        backgroundColor: _theme.palette.primary.main,
        borderColor: _theme.palette.primary.main,
        color: "white"
      },
      "&:hover, &:focus": {
        backgroundColor: _theme.palette.primary.dark,
        borderColor: _theme.palette.primary.dark
      },
      backgroundColor: _theme.palette.primary.main,
      borderColor: _theme.palette.primary.main,
      color: "white"
    },
    containedSizeSmall: {
      fontSize: "0.75rem",
      padding: "".concat(_theme.spacing[1], " ").concat(_theme.spacing[2])
    },
    outlined: {
      "&.Mui-disabled": {
        backgroundColor: "white",
        borderColor: _theme.palette.brand.grey.charcoal,
        color: _theme.palette.brand.grey.charcoal
      },
      "&:hover, &:focus": {
        backgroundColor: "white",
        borderColor: _theme.palette.primary.main,
        color: _theme.palette.primary.main
      },
      backgroundColor: "white",
      borderColor: _theme.palette.brand.grey.charcoal,
      color: _theme.palette.brand.grey.charcoal,
      padding: "".concat(_theme.spacing[2], " ").concat(_theme.spacing[3])
    },
    outlinedSizeSmall: {
      fontSize: "0.75rem",
      padding: "".concat(_theme.spacing[1], " ").concat(_theme.spacing[2])
    },
    root: {
      "&.Mui-focusVisible": {
        boxShadow: "0 0 0 2px ".concat(_theme.palette.focusRing.main, ", 1px 2px 3px 1px ").concat(_theme.palette.focusRing.main, " !important")
      },
      border: "1px solid",
      borderRadius: "4px",
      fontSize: "0.75rem",
      fontWeight: "bold",
      lineHeight: 1,
      padding: "".concat(_theme.spacing[2], " ").concat(_theme.spacing[3]),
      textTransform: "none"
    },
    text: {
      // Background colour must be in rgba(0, 0, 0, x) format
      // to maintain colour compatibility with different backgrounds
      borderColor: "transparent",
      color: _theme.palette.brand.grey.charcoal,
      fontWeight: "normal",
      padding: "".concat(_theme.spacing[2], " ").concat(_theme.spacing[3])
    },
    textSizeSmall: {
      fontSize: "0.75rem",
      padding: "".concat(_theme.spacing[1], " ").concat(_theme.spacing[2])
    }
  }
};
exports.default = _default;